import InputEmail from './InputEmail';

/**
 * @description Input Email SignUp footer Implementation
 */
export default class InputEmailSignUp extends InputEmail {
    prefs() {
        return {
            field: 'field',
            ...super.prefs()
        };
    }
    init() {
        this.eventBus().on('signup.submitted', 'submittedSignUpForm');
    }
    subscribeFieldFocus() {
        // clear errors if email field is empty
        if (!this.ref(this.prefs().field).val()) {
            super.clearError();
        }

        // event for hiding of success message
        this.emit('focusin');
    }
    submittedSignUpForm() {
        this.ref(this.prefs().field).val('');
    }
    focusOut() {
        this.activateSubmitButton();
    }
    checkboxState() {
        this.activateSubmitButton();
    }
    activateSubmitButton() {
        this.eventBus().emit('signup.submitButtonState', super.validate());
    }
}